import { useEffect, useState } from 'react';

import { DateInputWithConfirm, getStringFromDate } from 'shared-components';

import { IDate, ITravelStatus } from '../../../../../../../../../types';
import { validateDate } from '../../../../../../../../../utilities/validateDate';

interface IProps {
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
}
export const NewArrivedDate = (props: IProps) => {
  const {
    setComplete,
    additionalAnswers: { setAnswers },
    travelStatus: { status }
  } = props;

  const [dateState, setDateState] = useState<IDate>({
    DD: '',
    MM: '',
    YYYY: ''
  });

  const [newArrivedDateError, setNewArrivedDateError] = useState('');

  useEffect(() => {
    if (!newArrivedDateError.length && dateState.DD?.length && dateState.MM?.length && dateState.YYYY?.length === 4) {
      const newDate = getStringFromDate(dateState);
      setAnswers({ bookedDate: newDate });

      setComplete(true);
    } else {
      setComplete(false);
    }
  }, [dateState, setAnswers, setComplete, status, newArrivedDateError]);

  return (
    <>
      <DateInputWithConfirm
        value={dateState}
        errorText={newArrivedDateError}
        label="What is the new date of your arrival in the UK?"
        subText="Please enter the arrival date as stated on your travel booking"
        onChangeDD={(evt: any) => {
          const value = evt.currentTarget.value;
          setDateState(prevValue => ({ ...prevValue, DD: value }));
        }}
        onChangeMM={(evt: any) => {
          const value = evt.currentTarget.value;
          setDateState(prevValue => ({ ...prevValue, MM: value }));
        }}
        onChangeYY={(evt: any) => {
          const value = evt.currentTarget.value;
          if (value.length === 4) {
            setNewArrivedDateError(
              validateDate({
                ...dateState,
                YYYY: value
              })
            );
          }
          setDateState(prevValue => ({ ...prevValue, YYYY: value }));
        }}
        onBlur={() => setNewArrivedDateError(validateDate(dateState))}
      />
    </>
  );
};
